import React from 'react';
import { Button } from 'react-bootstrap';
import { isChunkLoadError } from './release-version.utils';
import './version-update.styles.scss';

export const CHUNK_RELOAD_KEY = 'petrocard:chunk-reload-release';

class ChunkLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) {
      return;
    }

    const currentVersion = this.props.currentVersion || process.env.REACT_APP_RELEASE_VERSION || 'unknown';
    const reloadPage = this.props.reloadPage || (() => window.location.reload());

    try {
      if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY) !== currentVersion) {
        window.sessionStorage.setItem(CHUNK_RELOAD_KEY, currentVersion);
        reloadPage();
      }
    } catch (storageError) {
      // Storage can be unavailable in restricted browsing modes.
    }
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <main className="version-load-error" role="alert">
        <h1>PetroCard could not load this page.</h1>
        <p>Please reload to get the latest application version.</p>
        <Button variant="danger" onClick={() => window.location.reload()}>
          Reload now
        </Button>
      </main>
    );
  }
}

export default ChunkLoadErrorBoundary;
